var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemarkableCityWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0977 18.1956V6.50109H17.3241C16.8922 3.95301 14.6704 2 12.0024 2C9.33443 2 7.10771 3.94827 6.6807 6.50109H3.90216V18.1956H3V19.9951H8.39861V11.8998H15.5967V20H20.9953V18.1957L20.0977 18.1956Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2422 13.639H13.7578V19.7938H10.2422V13.639Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemarkableCityWhite);
export default __webpack_public_path__ + "static/media/remarkable-city-white.d761f0fbcd677cbcfad212d008654110.svg";
export { ForwardRef as ReactComponent };